<template>
    <div class="cards-preview" style="display: flex;justify-content: space-around;margin-top: 90px;float: left;width: 100%;">
        <div v-if="card" class="cards-preview-container" style="position: relative;">
            <div class="x" style="right:-40px;top:-60px" @click="$router.push('/')"></div>
            <Card :card="card" @editCard="$emit('editCard',card)" />
        </div>
    </div>
</template>

<script>

import Card from '@/components/Card.vue'
import WebSoc from '@/utils/WebSoc.js'

export default {
    name: 'view-card',
    components: {
        Card
    },
    computed: {
        client_id () { return this.$store.state.client_id }
    },
    data () {
        return {
            card: false
        }
    },
    mounted () {
        this.getCard(this.$route.params._id);
    },
    methods: {
        getCard ( _id ) {
            console.log({ _id, client_id: this.client_id });
            WebSoc.SEND('get',{ DB: 'cards', _id },card => {
                if ( card.client_id != this.client_id ) return console.log('this.client_id != card.client_id',this.client_id, card.client_id);
                console.log('card',card);
                this.card = card;
            })
        },
        editCard ( card ) {
            console.log('editCard',card);
        }
    }
}

</script>